import { Colors } from '../../../../utils/resources/colors';
import { EnglishToneRowCSSStyleImpl } from '../../../toolkit/toneoptions/tone/englishtonerowcss';


export class PlaylistEnglishToneRowCSSStyleImpl extends EnglishToneRowCSSStyleImpl
{ 
    getLikeCSSStyle(): object 
    {
        return{
            // width:'79px',
            height:'100%',
            flex:'0.003',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'1px solid '+this.getResources().getColor(Colors.color_3),
            padding:'28px 17px',
            cursor:'pointer',
            // display:"flex",
        };
    }  

    getPlayDivCSSStyle():object
    {
        return{
            // width:'79px',
            flex:'0.003',
            height:'100%',
            marginLeft: "auto",
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // border:'none',
            padding:'28px 16px',
            cursor:'pointer',
            // display:"flex",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/englishtonerowcss.tsx